export default "__VITE_ASSET__f46c6f90__"